import { render, staticRenderFns } from "./CelphoneIcon.vue?vue&type=template&id=4dcf016c&"
import script from "./CelphoneIcon.vue?vue&type=script&lang=ts&"
export * from "./CelphoneIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports